export type LanguageModelInfo = {
  name: string;
  architecture: string;
  url: string;
  image: string;
  prompt_template: string;
  size: number;
  units: 'GB' | 'MB';
  use: string;
  language: string;
};

export type LanguageModel = {
  id: string;
  filename: string;
  current: boolean;
  downloaded: boolean | undefined;
  has_info: boolean;
  isDownloading: boolean;
  info: LanguageModelInfo;
};

export interface DownloadProgress {
  model_filename: string;
  progress: number;
  total: number;
  percentage: number;
}

export interface Download {
  model: LanguageModel;
  downloadProgress: DownloadProgress | null;
  unlisteners?: Unlisteners;
}

type UnlistenFn = () => void;

export interface Unlisteners {
  progress: UnlistenFn;
  complete: UnlistenFn;
}

export function getTranscribeModels(): LanguageModel[] {
  return [
    {
      id: 'ggml-small-q5_1',
      filename: 'ggml-small-q5_1.bin',
      current: false,
      downloaded: undefined,
      has_info: true,
      isDownloading: false,
      info: {
        name: 'Small',
        architecture: 'aarch64-apple-darwin',
        url: 'https://huggingface.co/ggerganov/whisper.cpp/resolve/main/ggml-small-q5_1.bin',
        image: '',
        prompt_template: 'Multilingual | Fastest',
        language: 'Multilingual',
        use: 'Fastest',
        size: 142,
        units: 'MB'
      }
    },
    {
      id: 'ggml-medium.en-q5_0',
      filename: 'ggml-medium.en-q5_0.bin',
      current: false,
      downloaded: undefined,
      has_info: true,
      isDownloading: false,
      info: {
        name: 'Medium',
        architecture: 'aarch64-apple-darwin',
        url: 'https://huggingface.co/ggerganov/whisper.cpp/resolve/main/ggml-medium.en-q5_0.bin',
        image: '',
        prompt_template: 'English only | Balanced',
        language: 'English only',
        use: 'Balanced',
        size: 0.5,
        units: 'GB'
      }
    },
    {
      id: 'ggml-large-v3-turbo-q8_0',
      filename: 'ggml-large-v3-turbo-q8_0.bin',
      current: false,
      downloaded: undefined,
      has_info: true,
      isDownloading: false,
      info: {
        name: 'Best',
        architecture: 'aarch64-apple-darwin',
        url: 'https://huggingface.co/ggerganov/whisper.cpp/resolve/main/ggml-large-v3-turbo-q8_0.bin',
        image: '',
        prompt_template: 'Multilingual | Highest quality',
        language: 'Multilingual',
        use: 'Highest quality',
        size: 0.8,
        units: 'GB'
      }
    }
  ];
}
